import React from "react";
import { Link } from "react-router-dom";
import LoginForm from "../Login/loginForm";

class Login extends React.Component {
  render() {
    return (
      <div className="contact">
        <div className="row mx-0">
          <div className="col-12 col-xl-6">
            <LoginForm />
          </div>
          <div className="col-6 d-none d-xl-block contactRight loginRight">
            <Link to="/" className="btn closeBtn">
              X
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
